var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSpinnerPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.614659 22.6582C-0.669338 17.8576 0.110539 12.9902 2.4094 9.00131C4.70826 5.01243 8.52611 1.90206 13.3181 0.615764C22.9019 -1.95683 32.753 3.74086 35.321 13.3419C35.642 14.5421 34.931 15.7756 33.733 16.0972C32.5351 16.4188 31.3037 15.7066 30.9827 14.5064C29.0567 7.30565 21.6684 3.03238 14.4805 4.96183C10.8865 5.92655 8.02315 8.25934 6.299 11.251C4.57486 14.2427 3.98995 17.8932 4.95295 21.4936C6.87894 28.6944 14.2672 32.9677 21.4551 31.0383C22.6531 30.7167 23.8845 31.4289 24.2055 32.629C24.5265 33.8292 23.8156 35.0627 22.6176 35.3843C13.0337 37.9569 3.18265 32.2592 0.614659 22.6582Z",
    fill: "#F5DADF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinnerPink);
export default __webpack_public_path__ + "static/media/iconSpinnerPink.b0d1c25099e0b57803e73096406f6e27.svg";
export { ForwardRef as ReactComponent };